import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.card-title',
		defaultMessage: 'Create request type',
		description: 'Card title when creating a JSM request type; name is the request type name',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.confirm-button',
		defaultMessage: 'Create',
		description: 'Label for the confirm button when creating a JSM request type',
	},
	expandSection: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.expand-section',
		defaultMessage: 'Show more',
		description: 'Accessible label for expanding the card body',
	},
	collapseSection: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.collapse-section',
		defaultMessage: 'Show less',
		description: 'Accessible label for collapsing the card body',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.create-request-type.success-pill',
		defaultMessage: `You've created "{name}"`,
		description:
			'Pill message after create JSM request type succeeds; name is the request type name',
	},
});
